import { Component, computed, inject } from '@angular/core';
import { FooterService } from '../../services/footer.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError, of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-footer-legals',
  imports: [CommonModule, RouterModule],
  templateUrl: './footer-legals.component.html',
  styleUrl: './footer-legals.component.scss',
})
export class FooterLegalsComponent {
  private readonly footerService = inject(FooterService);

  // pages = toSignal(
  //   this.footerService.getAllPages().pipe(
  //     map((result) => result),
  //     catchError((err) => {
  //       console.error(err);
  //       return of([]);
  //     }),
  //   ),
  //   { initialValue: [] },
  // );

  // constructor() {
  //   effect(() => {
  //     console.log(this.pages());
  //   });
  // }

  private pagesResponse = toSignal(
    this.footerService.getAllPages().pipe(
      catchError((err) => {
        console.error(err);
        return of([]);
      }),
    ),
    { initialValue: [] },
  );

  pages = computed(() => this.pagesResponse());
}
